import { useCallback } from 'react';
import {
  Button,
  IconStatusCorrect,
  Text,
} from '@adc/parallax-component-library';
import { Dialog } from '@tamagui/dialog';

import { ModalContent } from '~/components/ModalContent';
import { ModalOverlay } from '~/components/ModalOverlay';
import { useModal } from '~/features/modals/useModal';
import { buildTestId } from '~/utils/buildTestId';

type IDNAddedModalProps = {
  testID: string;
  idnId: string;
  idnName: string;
  handleViewIDNProfile: () => void;
};

export const IDNAddedModal = ({
  testID,
  idnId,
  idnName,
  handleViewIDNProfile,
}: IDNAddedModalProps) => {
  const { closeModal } = useModal();

  const onClose = useCallback(() => {
    closeModal('IDNAdded');
  }, [closeModal]);

  const handleAddAdminToIDN = () => {
    console.warn('TODO: navigate to add admin to IDN', { idnId });
  };

  const onOpenChange = (open: boolean) => {
    if (!open) {
      onClose();
    }
  };

  const onProfileView = useCallback(() => {
    onClose();
    handleViewIDNProfile();
  }, [onClose, handleViewIDNProfile]);

  return (
    <Dialog open onOpenChange={onOpenChange} modal>
      <Dialog.Portal testID={buildTestId({ testID, suffix: 'portal' })}>
        <ModalOverlay
          testID={buildTestId({
            testID,
            suffix: 'overlay',
          })}
        />

        <ModalContent
          testID={testID}
          key="content"
          paddingBottom="$12"
          maxWidth={800}
          alignItems="center"
        >
          <IconStatusCorrect size="M" color="$support.positive.default" />
          <Text
            type="$h3.strong"
            testID={buildTestId({
              testID,
              suffix: 'title',
            })}
            paddingTop="$2"
          >
            IDN Added
          </Text>

          <Text type="$h4.default" color="$text.60" paddingTop="$1">
            {idnName} has been added.
          </Text>

          <Button
            variant="secondary"
            label="Add Admin to IDN"
            onPress={handleAddAdminToIDN}
            marginTop="$8"
            // @ts-expect-error Parallax doesn't type this prop
            minWidth={256}
            testID={buildTestId({
              testID,
              suffix: ['button', 'add', 'admin', 'idn'],
            })}
          />

          <Button
            variant="secondary"
            label="View IDN Profile"
            onPress={onProfileView}
            marginTop="$4"
            // @ts-expect-error Parallax doesn't type this prop
            minWidth={256}
            testID={buildTestId({
              testID,
              suffix: ['button', 'idn', 'profile'],
            })}
          />

          <Button
            variant="primary"
            label="Done"
            onPress={onClose}
            marginTop="$4"
            // @ts-expect-error Parallax doesn't type this prop
            minWidth={256}
            testID={buildTestId({
              testID,
              suffix: ['button', 'done'],
            })}
          />
        </ModalContent>
      </Dialog.Portal>
    </Dialog>
  );
};
